export enum MouseCursor {
  Auto = 'auto',
  Arrow = 'default',
  Pointer = 'pointer',
  Move = 'move',
  Text = 'text',
  Wait = 'wait',
  None = 'none',
}
